import { Select, Tag } from "antd";

// Lowercased with accents stripped, so "turkiye" finds Türkiye and
// "curacao" finds Curaçao — nobody types the diacritics into a search.
const searchable = (text) =>
  String(text).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

const tagRender = (props) => {
  const { label, value, closable, onClose } = props;
  const onPreventMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      color={ 'green' }
      onMouseDown={ onPreventMouseDown }
      closable={ closable }
      onClose={ onClose }
      style={ {
        marginRight: 3,
      } }
    >
      { label }
    </Tag>
  );
};
const BaseSelectWithSearch = (props) => {
  return (

    <Select
      allowClear
      { ...props }
      showSearch={ true }
      placeholder={ props.placeholder }
      // Options are plain { label, value } objects, so antd hands the
      // object itself here — reading option.props.label threw on the
      // first keystroke and left every one of these selects unsearchable.
      //
      // An option may also carry `name`: the plain-text version of a
      // label that is a node rather than a string (the country picker
      // draws a flag beside the name). Without it, stringifying a node
      // gives "[object Object]" and the list matches nothing.
      filterOption={ (input, option) =>
        searchable(option?.name ?? option?.label ?? '').includes(searchable(input))
      }
      // rc-select flattens `options` with a forEach, so anything that is
      // not an array takes the whole screen down rather than rendering an
      // empty list — a screen whose options are still being fetched, or
      // came back as {} or null, should show no choices, not a blank app.
      options={ Array.isArray(props.options) ? props.options : [] }
      tagRender={ tagRender }
    />

  )
}

export default BaseSelectWithSearch